import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import subtidal_logo from '../logo-navy.svg';

const GLOBAL_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700&family=Outfit:wght@300;400;500;600;700&display=swap');
`;

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [focus, setFocus] = useState(null);

  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/dashboard');
    } catch (err) {
      setError('Incorrect username or password. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = (key) => ({
    width: '100%',
    boxSizing: 'border-box',
    padding: '14px 16px',
    fontSize: 16,
    borderRadius: 10,
    border: `1.5px solid ${focus === key ? '#263B4B' : '#dcd6c8'}`,
    background: '#fff',
    color: '#1f2a2e',
    outline: 'none',
    boxShadow: focus === key ? '0 0 0 4px rgba(38,59,75,0.10)' : 'none',
    transition: 'border-color .15s, box-shadow .15s',
    fontFamily: 'inherit',
  });

  return (
    <div style={{
      minHeight: '100vh',
      display: 'grid',
      placeItems: 'center',
      background: '#f6f3ec',
      padding: 24,
      fontFamily: "'Outfit', sans-serif",
    }}>
      <style>{GLOBAL_STYLES}</style>
      <div style={{ width: '100%', maxWidth: 420 }}>
        {/* Logo */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 28 }}>
          <img src={subtidal_logo} alt="Subtidal" style={{ height: 36, width: 'auto' }} />
        </div>

        {/* Card */}
        <div style={{
          background: '#fff',
          borderRadius: 20,
          border: '1px solid #ece7db',
          boxShadow: '0 18px 48px rgba(31,42,46,0.10)',
          padding: '36px 32px',
        }}>
          <h1 style={{
            fontFamily: "'Fraunces', Georgia, serif",
            fontSize: 28,
            fontWeight: 600,
            letterSpacing: '-0.02em',
            color: '#1f2a2e',
            margin: '0 0 6px',
          }}>
            Welcome back
          </h1>
          <p style={{ margin: '0 0 26px', color: '#6f6a5f', fontSize: 15.5, lineHeight: 1.5 }}>
            Sign in to view real-time water-safety conditions for your ponds.
          </p>

          {error && (
            <div style={{
              background: '#f7e3e0',
              border: '1px solid #eac3bd',
              borderRadius: 10,
              padding: '12px 16px',
              marginBottom: 20,
              color: '#9e2b25',
              fontSize: 14.5,
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
              <label style={{ display: 'block' }}>
                <span style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#46505a', marginBottom: 7 }}>
                  Username
                </span>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  onFocus={() => setFocus('user')}
                  onBlur={() => setFocus(null)}
                  placeholder="name@association.org"
                  autoComplete="username"
                  autoFocus
                  style={inputStyle('user')}
                  required
                />
              </label>

              <label style={{ display: 'block' }}>
                <span style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#46505a', marginBottom: 7 }}>
                  Password
                </span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={() => setFocus('pw')}
                  onBlur={() => setFocus(null)}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  style={inputStyle('pw')}
                  required
                />
              </label>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                marginTop: 26,
                padding: '14px',
                fontSize: 16,
                fontWeight: 600,
                color: '#fff',
                background: loading ? '#5a7a8e' : '#263B4B',
                border: 'none',
                borderRadius: 10,
                cursor: loading ? 'not-allowed' : 'pointer',
                fontFamily: 'inherit',
                transition: 'background .15s',
              }}
              onMouseEnter={(e) => { if (!loading) e.currentTarget.style.background = '#1c2e3b'; }}
              onMouseLeave={(e) => { if (!loading) e.currentTarget.style.background = '#263B4B'; }}
            >
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <div style={{ marginTop: 20, textAlign: 'center' }}>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              style={{ color: '#46708a', fontSize: 14.5, textDecoration: 'none', fontWeight: 500 }}
            >
              Forgot your password?
            </a>
          </div>
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, color: '#9a9384', fontSize: 13.5 }}>
          Trouble signing in? Contact your association administrator.
        </p>
      </div>
    </div>
  );
};

export default Login;
